<template>
  <div class="what-youll-lose">
    <h2 class="h3 mb-2"><b>Here's what you'll lose.</b></h2>
    <p class="text-muted mb-4">Cancelling removes the following from your account.</p>

    <div class="card what-youll-lose__callout mb-4">
      <div class="card-body d-flex align-items-center gap-3">
        <span class="material-icons what-youll-lose__callout-icon">bolt</span>
        <p class="mb-0">
          <b>Did you know?</b> Hikers with PRO+ were <i>3 times</i> more likely to hit the trail last year?
        </p>
      </div>
    </div>

    <div v-for="feature in features" :key="feature.title" class="d-flex align-items-start gap-3 mb-3">
      <span class="material-icons what-youll-lose__feature-icon">{{ feature.icon }}</span>
      <div>
        <p class="mb-0"><b>{{ feature.title }}</b></p>
        <p class="text-muted mb-0">{{ feature.subtitle }}</p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const features = [
  {
    icon: "map",
    title: "Premium and 3D maps",
    subtitle: "Trusted national and independent maps made by the experts.",
  },
  {
    icon: "cloud",
    title: "Weather Maps",
    subtitle: "Check the conditions before you leave for your hike",
  },
  {
    icon: "print",
    title: "Print Maps",
    subtitle: "Print a PRO+ maps so you're never left without a guide.",
  },
  {
    icon: "share_location",
    title: "Live Locator",
    subtitle: "Share your live location with friends and family so they know where you are.",
  },
  {
    icon: "notifications_active",
    title: "Off route notifications",
    subtitle: "Get notified if you stray off course through an alert on your device",
  },
];
</script>

<style scoped lang="scss">
.what-youll-lose {
  &__callout {
    border-radius: 12px;
    background-color: rgba(255, 215, 0, 0.12);
    border-color: rgba(255, 215, 0, 0.4);
  }

  &__callout-icon {
    color: var(--yellow, #ffd700);
  }

  &__feature-icon {
    color: var(--text-muted, #b2b2b2);
  }
}
</style>
